import { breakpoints, useMediaQuery } from '../customHook/useMediaQuery'

const mediaQuery = () => {
  const mediaQueryMobile = useMediaQuery(`(max-width: ${breakpoints[0].smartphone})`)
  const mediaQueryTablet = useMediaQuery(`(max-width: ${breakpoints[0].tablet})`)
  const mediaQueryLaptop = useMediaQuery(`(max-width: ${breakpoints[0].laptop})`)
  return {
    mobile: mediaQueryMobile,
    tablet: mediaQueryTablet,
    laptop: mediaQueryLaptop,
  }
}

export default mediaQuery
